import React from 'react';

// import UniversalSearch from 'components/UniversalSearch';
import UniversalSearchV1 from 'components/UniversalSearchV1';
import styled from 'styled-components';

/**
 * @deprecated 8-04-2025
 */
export default function SearchContainer() {
  return (
    <Container>
      {/* <Search /> */}
      <StyledSearchContainer>
        {
          // <UniversalSearch />
        }
        <UniversalSearchV1 />
      </StyledSearchContainer>
    </Container>
  );
}

const Container = styled.div`
  display: inline-block;
  text-align: left;
  display: flex;
  justify-content: flex-start;
  flex: 0 0 30ch;
  ${(props) => props.theme.breakpoints.up('md')} {
    flex-basis: 30ch;
  }
  ${(props) => props.theme.breakpoints.up('xl')} {
    flex-basis: 25ch;
  }
`;

const StyledSearchContainer = styled.div`
  width: 100%;
  ${(props) => props.theme.breakpoints.up('sm')} {
    width: 90%;
  }
`;
